module.exports = __webpack_public_path__ + "static/media/round-triangle-violet.cadcc5ba.svg";